import { AfterViewInit, Directive } from '@angular/core';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { FormControlDirective } from '@angular/forms';

@Directive({
// tslint:disable-next-line: directive-selector
  selector: 'ngx-mat-select-search'
})
export class MatSelectSearchPatchDirective implements AfterViewInit {

  constructor(private matSelectSearchComponent: MatSelectSearchComponent, private formControlDirective: FormControlDirective) {
  }

  ngAfterViewInit(): void {
    (this.matSelectSearchComponent.searchSelectInput.nativeElement as HTMLInputElement).value = this.formControlDirective.control.value;
  }

}
